import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const MIN_SHOW_MS = 900;

export const Preloader = () => {
  const [done, setDone] = useState(false);

  useEffect(() => {
    const start = performance.now();
    let timer;
    const finish = () => {
      const wait = Math.max(0, MIN_SHOW_MS - (performance.now() - start));
      timer = setTimeout(() => setDone(true), wait);
    };
    if (document.readyState === "complete") finish();
    else window.addEventListener("load", finish, { once: true });
    return () => {
      window.removeEventListener("load", finish);
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    document.documentElement.style.overflow = done ? "" : "hidden";
    return () => { document.documentElement.style.overflow = ""; };
  }, [done]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="site-preloader"
          className="fixed inset-0 z-[200] bg-[#0A0A0A] flex flex-col items-center justify-center"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.6, ease: "easeInOut" } }}
        >
          <motion.img
            src="/logo-full.webp"
            alt="vic wrap studio"
            className="w-44 sm:w-60 h-auto"
            initial={{ opacity: 0, scale: 0.92 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          />
          <div className="mt-10 h-[2px] w-40 bg-white/10 overflow-hidden rounded-full">
            <motion.div
              className="h-full bg-gradient-to-r from-[#FF2A2A] to-[#FF6B00]"
              initial={{ x: "-100%" }}
              animate={{ x: "100%" }}
              transition={{ duration: 1.1, repeat: Infinity, ease: "easeInOut" }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
